import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import type { ChangeIntentFilterEvent } from 'components/Table/components/SimpleFilter/types/ChangeFilterEvent';
import { submitSimpleFilters } from './submitSimpleFilters';

export type ChangeIntentFilterCommand = ChangeIntentFilterEvent;

export const changeIntentFilter: ApiTableCommandFactory<
  ChangeIntentFilterCommand
> = (cmdContext, dispatch) => async (command) => {
  cmdContext.updateState((draft) => {
    draft.intentFilters[command.column] = command.severity;
  });

  dispatch(submitSimpleFilters);
};
